import { NonIdealState } from "@blueprintjs/core";
import React from "react";

import { PlayContext } from "../../pages";
import { usePlayContextApi } from "../../pages/Play/hooks/use-play-context-api";
import { SportPlay } from "../../types";
import { getOutofBounds, parseHtml } from "../../utils";
import { PlayingSurface } from "../playing-surface/playing-surface";
import styles from "./play-frames-display.module.scss";

export interface PlayFramesDisplayProps {
  activePlay: SportPlay;
  frameZoom: number;
}

export const PlayFramesDisplay = ({ activePlay, frameZoom }: PlayFramesDisplayProps) => {
  const framesWithStencils = activePlay.frames.filter((frame) => frame.frameStencils && frame.frameStencils.length > 0);
  const playContextApi = usePlayContextApi(activePlay);

  // frame zoom is a value between 1 and 20
  // convert frame zoom to a percentage
  const courtWidth = frameZoom * 5 + "%";

  return (
    <PlayContext.Provider value={playContextApi}>
      <div className={styles.courtTableContainer}>
        {framesWithStencils.length > 0 ? (
          framesWithStencils.map((frame, index) => {
            return (
              <div style={{ width: courtWidth }} className={styles.frameContainer} key={index}>
                <div className={styles.frameLabel}>{frame.label}</div>
                <PlayingSurface
                  play={activePlay}
                  stencils={frame.frameStencils || []}
                  outOfBounds={getOutofBounds(activePlay)}
                  fitContainer={false}
                />
                <div className={styles.frameDescription}>{parseHtml(frame.description)}</div>
              </div>
            );
          })
        ) : (
          <NoStencilFrames />
        )}
      </div>
    </PlayContext.Provider>
  );
};

const NoStencilFrames = () => {
  return (
    <NonIdealState
      icon={"square"}
      title={"No Frames with Stencils"}
      description={"All frames in this play are empty."}
      layout={"vertical"}
    />
  );
};
